export const environment = {
  production: true,
  sentryUrl: 'https://ee415fa13ab64cedb60bc452f9d162db@sentry.io/1776635',
  docker:false,
  maintenance: false
};
